import useGoogleAdsManager from '@nuxt-common/site-monetization/app/composables/useGoogleAdsManager';
import useMeta from '@/composables/useMeta';
import useEnvParams from '@/composables/useEnvParams';
import { usePageDataStore } from '../stores/pageDataStore';
import usePageType from './usePageType';
import useDevice from './useDevice';

let tagParams;
const getSiteMonGAMTagsOnFacetSelection = () => {
  useGoogleAdsManager.initGAMTags(tagParams);
};

const initSiteMonGAMTags = () => {
  const { isPhone } = useDevice();
  const pageType = usePageType();
  const meta = useMeta();
  const store = usePageDataStore();
  const { brand, tagMngrEnv } = useEnvParams();
  const brandBlocked = store?.getSortableGrid?.brandBlocked || false;
  const sitemonPageType = {
    BROWSE: 'browse',
    SPLASH: 'catsplash',
    SUB_SPLASH: 'subsplash',
    SEARCH: 'search',
  };
  tagParams = {
    store,
    device: !isPhone ? 'desktop' : 'mobile',
    page: sitemonPageType[pageType.sitePageType],
    enableGAMAdsFromApp: meta.value?.properties?.enableGAMAdsFromApp || false,
    enableGAMImpressionTags: meta.value?.properties?.enableGAMImpressionTags || false,
    enableGAMClickTags: meta.value?.properties?.enableGAMClickTags || false,
    isBrandBlocked: brandBlocked,
    tagEnv: tagMngrEnv,
    brand,
    searchKeyword: meta?.value?.context?.searchTerm || '',
    catID: meta?.value?.analytics?.data?.categoryID || '',
    topLevelCatID: meta?.value?.analytics?.data?.topLevelCategoryID || '',
    categoryTreeIDs: meta?.value?.analytics?.data?.categoryTreeIDs || '',
    isGoogleAdPromoSlideshowEnabled: meta?.value?.properties?.isGoogleAdPromoSlideshowEnabled || false,
  };
  useGoogleAdsManager.initGAMTags(tagParams);
};

export default function useSiteMonGAMTags() {
  return {
    initSiteMonGAMTags,
    getSiteMonGAMTagsOnFacetSelection,
  };
}
